<jhi-result
    id="result"
    [exercise]="exercise"
    [result]="result"
    [participation]="participation"
    [isBuilding]="isBuilding"
    [isQueued]="isQueued"
    [short]="short"
    [showUngradedResults]="showUngradedResults"
    [showBadge]="showBadge"
    [showIcon]="showIcon"
    [missingResultInfo]="missingResultInfo"
    [isInSidebarCard]="isInSidebarCard"
    [showCompletion]="showCompletion"
    [estimatedCompletionDate]="estimatedCompletionDate"
    [buildStartDate]="buildStartDate"
    [showProgressBar]="showProgressBarInResult"
    [showProgressBarBorder]="showProgressBarBorder"
/>
